export default __webpack_public_path__ + "static/media/Michael.17b7336e.jpg";